// extracted by mini-css-extract-plugin
module.exports = {"svgSquare":"svgStyles_svgSquare__1K--F"};